/**
 * Owner: Masa Bayu
 * File: demo-author-store.ts
 * Date:Time: 2026-09-16 13:43
 * Description: Demo AuthorAccount + dashboard seed for T6-E1 shell surfaces.
 */

import {
  createAuthorCapableAccount,
  createAuthorWriterLaunchIntent,
  createQxreadAuthorAccount,
  createQxreadSession,
  projectAuthorDashboard,
  type CreateAuthorWriterLaunchResult,
  type QxreadAuthorAccount,
  type QxreadAuthorDashboardProjection,
  type QxreadAccount,
  type QxreadSession,
} from '@qx/qxread-core';

const DEMO_ACCOUNT_ID = 'qxrdacc_demo_author';
const DEMO_NOW = '2026-09-16T05:43:00.000Z';

let demoAccount: QxreadAccount = createAuthorCapableAccount({
  accountId: DEMO_ACCOUNT_ID,
  displayName: 'Demo Author',
});
let demoSession: QxreadSession = createQxreadSession({
  state: 'authenticated',
  accountId: DEMO_ACCOUNT_ID,
  issuedAt: DEMO_NOW,
});
let demoAuthor: QxreadAuthorAccount = createQxreadAuthorAccount({
  accountId: DEMO_ACCOUNT_ID,
  displayName: 'Demo Author',
  slug: 'demo-author',
  createdAt: DEMO_NOW,
  updatedAt: DEMO_NOW,
});
let lastWriterLaunch: CreateAuthorWriterLaunchResult | null = null;

export function resetDemoAuthorStore(): void {
  demoAccount = createAuthorCapableAccount({
    accountId: DEMO_ACCOUNT_ID,
    displayName: 'Demo Author',
  });
  demoSession = createQxreadSession({
    state: 'authenticated',
    accountId: DEMO_ACCOUNT_ID,
    issuedAt: DEMO_NOW,
  });
  demoAuthor = createQxreadAuthorAccount({
    accountId: DEMO_ACCOUNT_ID,
    displayName: 'Demo Author',
    slug: 'demo-author',
    createdAt: DEMO_NOW,
    updatedAt: DEMO_NOW,
  });
  lastWriterLaunch = null;
}

export function getDemoAuthorAccount(): QxreadAuthorAccount {
  return demoAuthor;
}

export function getDemoAuthorDashboard(): QxreadAuthorDashboardProjection {
  return projectAuthorDashboard({
    session: demoSession,
    account: demoAccount,
    authorAccount: demoAuthor,
    publicationCount: 0,
    projectedAt: DEMO_NOW,
  });
}

export function launchDemoQxWriter(): CreateAuthorWriterLaunchResult {
  lastWriterLaunch = createAuthorWriterLaunchIntent({
    session: demoSession,
    account: demoAccount,
    authorAccount: demoAuthor,
    createdAt: DEMO_NOW,
  });
  return lastWriterLaunch;
}

export function getDemoWriterLaunch(): CreateAuthorWriterLaunchResult | null {
  return lastWriterLaunch;
}
